import * as React from 'react';

import { IRoutingBuildSuccessParams } from '../../../components/Map';
import { TInfrastructureItem } from '../../../types/map';

export const checkIsInfrastructureRoute = (
  ref: React.MutableRefObject<TInfrastructureItem | null>,
  params: IRoutingBuildSuccessParams,
) => {
  const point = ref.current;

  if (!point) {
    return false;
  }

  const wayPointTo = params.wayPoints.find(point => point.index === 1);
  const pointToCoordinates = wayPointTo && wayPointTo.coordinates;
  const isInfrastructureRoute =
    !!pointToCoordinates &&
    pointToCoordinates[0] === point.coordinates.lng &&
    pointToCoordinates[1] === point.coordinates.lat;

  if (isInfrastructureRoute) {
    ref.current = null;
  }

  return isInfrastructureRoute;
};
